<template>
  <div class="vote-ranking">
    <div class="ranking-container">
      <div class="ranking-search-bar">
        <div class="filter-left">
          <img src="@/assets/images/trophy.png" alt="logo" class="logo" />
          <span class="title">大赛投票实时排行榜</span>
        </div>
        <div class="filter-right">
          <form class="search-input" @submit.prevent="onSearch">
            <input placeholder="请输入关键词进行搜索" v-model="keyword" />
            <Icon type="ios-search" style="cursor:pointer;" @click="onSearch" />
          </form>
        </div>
      </div>
      <div class="ranking-header">
        <div class="header-item rank">排名</div>
        <div class="header-item work">作品信息</div>
        <div class="header-item author">作者</div>
        <div class="header-item votes">当前总票数</div>
        <div class="header-item action">操作</div>
      </div>
      <div class="ranking-list">
        <transition-group name="list-fade">
          <div v-for="(item, index) in rankingList" :key="item.match_id" class="ranking-item">
            <!-- 排名 -->
            <div class="item-rank">
              <img v-if="item.rank === 1" class="rank-icon" src="@/assets/images/ico_first_place.png"></img>
              <img v-else-if="item.rank === 2" class="rank-icon" src="@/assets/images/ico_second_place.png"></img>
              <img v-else-if="item.rank === 3" class="rank-icon" src="@/assets/images/ico_third_place.png"></img>
              <span v-else class="rank-num">{{ item.rank }}</span>
            </div>
            <!-- 作品 -->
            <div class="item-work">
              <div class="work-cover-box">
                <img :src="item.match_post_image | default_img" class="work-cover" />
              </div>
              <div class="work-name">{{ item.match_post_name }}</div>
            </div>
            <!-- 作者 -->
            <div class="item-author">
              <img :src="item.avatar | default_img" class="author-avatar" />
              <span class="author-name">{{ item.author }}</span>
            </div>
            <!-- 票数 -->
            <div class="item-votes">
              <span class="vote-count">{{ item.total_vote || 0 }}票</span>
            </div>
            <!-- 操作 -->
            <div class="item-action">
              <span class="detail-btn" @click="handleOpenVoteDialog(item.vote_qrcode)">查看作品详情</span>
              <!-- <span v-if="userInfo.id === item.user_id" class="vote-btn" @click="handleOpenVoteDetailDialog()">投票详情</span> -->
              <span v-if="item.has_vote === 0" class="vote-btn" @click="handleOpenVoteDialog(item.vote_qrcode)">为TA投票</span>
              <span v-else class="voted-btn" @click="handleOpenVoteDialog(item.vote_qrcode)">已投票</span>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
    <!-- 当自己有作品时才展示 -->
    <div v-if="ownerWorkerInfo.rank_uuid" class="bottom-info" :style="{ bottom: footerHeight + 'px' }">
      <div class="vote-detail-box">
        <span class="rank-num">{{ ownerWorkerInfo.rank }}</span>
        <div class="vote-detail-info">
          <div class="current-rank-num">
            <span>我的当前排名：第<span class="num-value">{{ ownerWorkerInfo.rank }}</span>名</span>
          </div>
          <div class="current-vote-num">
            <span>当前总票数：{{ ownerWorkerInfo.total_vote }}票</span>
            <span class="today-vot-num">今日获票：{{ ownerWorkerInfo.today_vote }}票</span>
          </div>
        </div>
      </div>
      <div class="work-detail-box">
        <div class="work-cover-box">
          <img :src="ownerWorkerInfo.match_post_image | default_img" class="work-cover" />
        </div>
        <div class="work-name">{{ ownerWorkerInfo.match_post_name }}</div>
      </div>
      <div class="option-btn-box">
        <span class="goods-detail-btn" @click="handleOpenVoteDialog(ownerWorkerInfo.vote_qrcode)">查看商品详情</span>
        <span class="view-vote-btn" @click="handleOpenVoteDetailDialog()">查看投票</span>
      </div>
    </div>
    <VoteDetailDialog :visible.sync="showVoteDetail" :rankId="ownerWorkerInfo.rank_uuid" @handleVote="handleOpenVoteDialog(ownerWorkerInfo.vote_qrcode)" />
    <VoteDialog :visible.sync="showVote" :qrcodeUrl="voteQrcode" />
  </div>
</template>

<script>
import VoteDetailDialog from './VoteDetailDialog.vue';
import VoteDialog from './VoteDialog.vue';
import { GetMatchVoteRankingList, GetMatchVoteRankingMyRank } from '@/api/social';
import { mapState } from 'vuex';
export default {
  name: 'VoteRanking',
  components: {
    VoteDetailDialog,
    VoteDialog,
  },
  props: {
    uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rankingList: [],
      timer: null,
      keyword: '', // 搜索关键词
      currentWorkInfo: {}, // 当前作品信息
      showVoteDetail: false, // 投票详情弹窗显示状态
      showVote: false, // 投票弹窗显示状态
      footerHeight: 50, // 底部高度
      ownerWorkerInfo: {}, // 当前用户的作品信息
      voteQrcode: '', // 投票二维码
    };
  },
  computed:{
    ...mapState(['userInfo'])
  },
  mounted() {
    this.getRankingList();
    this.getOwnerWorkerInfo();
    this.updateFooterHeight();
    window.addEventListener('resize', this.updateFooterHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFooterHeight);
  },
  methods: {
    onSearch() {
      this.getRankingList();
    },
    async getRankingList() {
      try {
        // 这里需要根据实际API调整
        const { data } = await GetMatchVoteRankingList({ match_uuid: this.uuid, keyword: this.keyword });
        console.log('data', data);
        this.rankingList = data;
        console.log('this.rankingList', this.rankingList);
      } catch (e) {
        console.error('获取排行榜数据失败', e);
        this.$layer.msg(e.msg || '获取数据失败');
      }
    },
    async getOwnerWorkerInfo () {
      try {
        // 这里需要根据实际API调整
        const { data } = await GetMatchVoteRankingMyRank({ match_uuid: this.uuid });
        console.log('data', data);
        this.ownerWorkerInfo = data || {};
        console.log('this.ownerWorkerInfo', this.ownerWorkerInfo);
      } catch (e) {
        console.error('获取自己作品失败', e);
      }
    },
    handleOpenVoteDetailDialog() {
      // this.currentWorkInfo = item;
      this.showVoteDetail = true;
    },
    handleOpenVoteDialog(qrcode) {
      this.voteQrcode = qrcode;
      console.log('qrcode', qrcode);
      this.showVote = true;
    },
    updateFooterHeight() {
      // 获取底部元素的高度
      const footer = document.querySelector('.light-footer') || document.querySelector('.dark-footer');
      if (footer) {
        this.footerHeight = footer.offsetHeight;
      }
    },
    goDetail(product_uuid) {
      this.$router.push({name:'GoodsDetail',params:{product_uuid}});
    }
  }
};
</script>

<style lang="scss" scoped>
.vote-ranking {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F8F9FB;

  .ranking-container {
    width: 1114px;
    margin-top: 12px;
    background: #ffffff;
    padding: 0 32px;
    padding-bottom: 80px;

    .ranking-search-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 19px;

      .filter-left {
        display: flex;
        align-items: center;

        .logo {
          width: 28px;
          height: 32px;
        }

        .title {
          margin-left: 8px;
          font-weight: bold;
          font-size: 20px;
          line-height: 30px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .filter-right {
        display: flex;
        align-items: center;
        column-gap: 17px;

        .search-input {
          width: 280px;
          height: 40px !important;
          border-radius: 20px !important;
          border: 1px solid #ebebeb;
          padding: 0 18px;
          display: flex;
          align-items: center;

          input {
            background: transparent;
            border: none;
            outline: none;
            height: 100%;
            flex: 1;
          }
        }
      }
    }

    .ranking-header {
      display: flex;
      background: #F8F9FB;
      border-radius: 8px 8px 0 0;
      padding: 10px 0px;
      margin-top: 15px;
      height: 42px;

      .header-item {
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #666666;
        text-align: center;
        font-style: normal;
        text-transform: none;

        &.rank {
          width: 110px;
        }

        &.work {
          width: 320px;
        }

        &.author {
          width: 180px;
        }

        &.votes {
          width: 200px;
        }

        &.action {
          width: 240px;
        }
      }
    }

    .ranking-list {

      .ranking-item {
        display: flex;
        align-items: center;
        height: 81px;
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #E3E3E3;
        padding: 8px 0;
        margin-top: 8px;

        &:hover {
          background: #FFEFF0;
        }

        .item-rank {
          width: 110px;
          text-align: center;

          .rank-icon {
            width: 40px;
            height: 40px;
          }

          .rank-num {
            display: inline-block;
            width: 30px;
            height: 30px;
            background-color: #f3f3f3;
            border-radius: 50%;

            font-weight: bold;
            font-size: 14px;
            line-height: 30px;
            color: #333333;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }

        .item-work {
          width: 320px;
          display: flex;
          align-items: center;
          // padding-left: 20px;

          .work-cover-box {
            width: 55px;
            height: 65px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #E3E3E3;
            margin-right: 12px;

            .work-cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }


          .work-name {
            width: 236px;
            font-weight: 400;
            font-size: 14px;
            line-height: 21px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .item-author {
          width: 180px;
          display: flex;
          align-items: center;
          justify-content: center;

          .author-avatar {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            margin-right: 8px;
            object-fit: cover;
          }

          .author-name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 148px;

            font-weight: 400;
            font-size: 12px;
            line-height: 18px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
        }

        .item-votes {
          width: 200px;
          text-align: center;

          .vote-count {
            font-weight: bold;
            font-size: 14px;
            line-height: 21px;
            color: #FF5967;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }

        .item-action {
          width: 240px;
          display: flex;
          justify-content: center;
          gap: 24px;

          .detail-btn {
            cursor: pointer;
            font-weight: 400;
            font-size: 12px;
            line-height: 28px;
            color: #666666;
            text-align: left;
            font-style: normal;
            text-transform: none;

            &:hover {
              color: #FA3D5B;
            }
          }

          .vote-btn {
            cursor: pointer;
            width: 72px;
            height: 28px;
            background: #FFFFFF;
            border-radius: 20px 20px 20px 20px;
            border: 1px solid #FA3D5B;

            font-weight: 400;
            font-size: 12px;
            line-height: 28px;
            color: #FF5967;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .voted-btn {
            width: 72px;
            height: 28px;
            background: #FA3D5B;
            border-radius: 20px 20px 20px 20px;

            font-weight: 400;
            font-size: 12px;
            // line-height: 18px;
            line-height: 28px;
            color: #FFFFFF;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }
    }
  }

  .bottom-info {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 88px;
    padding: 20px 0;
    z-index: 100;
    background: #FFEFF0;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: bottom 0.3s ease;

    .vote-detail-box {
      display: flex;
      align-items: center;

      .rank-num {
        display: inline-block;
        width: 36px;
        height: 36px;
        background: #FA3D5B;
        border-radius: 50%;

        font-weight: 400;
        font-size: 20px;
        line-height: 36px;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .vote-detail-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 12px;

        .current-rank-num {
          font-weight: bold;
          font-size: 16px;
          line-height: 24px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;

          .num-value {
            color: #FF5967;
          }
        }

        .current-vote-num {
          font-weight: 400;
          font-size: 14px;
          line-height: 21px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;

          .today-vot-num {
            margin-left: 12px;
          }
        }
      }
    }

    .work-detail-box {
      display: flex;
      align-items: center;
      margin-left: 100px;

      .work-cover-box {
        width: 55px;
        height: 65px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E3E3E3;
        margin-right: 12px;

        .work-cover {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }


      .work-name {
        width: 236px;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }

    .option-btn-box {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-left: 45px;

      .goods-detail-btn {
        cursor: pointer;
        width: 138px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 20px 20px 20px 20px;
        border: 1px solid #FA3D5B;

        font-weight: 400;
        font-size: 14px;
        line-height: 36px;
        color: #FF5967;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }

      .view-vote-btn {
        cursor: pointer;
        width: 138px;
        height: 36px;
        background: #FA3D5B;
        border-radius: 20px 20px 20px 20px;

        font-weight: 400;
        font-size: 14px;
        line-height: 36px;
        color: #FFFFFF;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}

// 列表动画效果
.list-fade-enter-active,
.list-fade-leave-active {
  transition: all 0.5s ease;
}

.list-fade-enter {
  opacity: 0;
  transform: translateX(-30px);
}

.list-fade-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.list-fade-move {
  transition: transform 0.5s ease;
}
</style>